import React from 'react';
import makeStyles from "@mui/styles/makeStyles";
import Box from "@mui/material/Box";
import { Tab, Typography } from '@mui/material';
import { useTheme } from '@mui/styles';
import { TabContext, TabList } from '@mui/lab';

const useStyles = makeStyles((theme) => ({
  root: {
    background: "white",
    display: "flex",
    width: 'fit-content',
    justifyContent: "space-between",
    border: '1px solid',
    borderColor: theme.palette.neutral["clr-500"],
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
    height: '44px'
  },
  tab: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
    cursor: "pointer",
    transition: "400ms ease-in-out",
    padding: theme.spacing(3,5),
    borderColor: theme.palette.neutral["clr-500"],
  },
  activeTab: {
    backgroundColor: theme.palette.secondary.main
  },
  simpleTab: {
    ...theme.typography['h6-semiBold'],
    textTransform: 'capitalize',
    display: 'flex',
    flexGrow: 1
  },
  tabList: {
    width: '100%', 
    '& .MuiTabs-flexContainer': {
      width: '100%', 
      display: 'flex',
    },
    '& .MuiTab-root': {
      flexGrow: 1, 
    }
  }
}));

function Tabs({
  value,
  options = [],
  width = '132px',
  onChange = () => { },
  ...props
}) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Box className={classes.root}>
      {
        options.map((option, index) => {
          return (
            <Box
              key={index}
              className={`${classes.tab} ${option._id === value ? classes.activeTab : ''}`}
              onClick={() => onChange(option._id)}
              style={{
                borderRight: index < options.length - 1 ? `1px solid ${theme.palette.neutral["clr-500"]}` : 'none',
                width: width
              }}
              {...props}
            >
              {
                option.icon
                  ? <img src={option.icon} alt={option.label} />
                  : null
              }
              <Typography variant="body01-bold" color={'neutral.clr-800'}>
                {option?.label || index}
              </Typography>
            </Box>
          )
        })
      }
    </Box>
  );
}

export default Tabs;

export const SimpleTabs = ({
  options = [],
  value = null,
  onChange = () => { }
}) => {
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    onChange(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
          <TabList 
            onChange={handleChange} 
            aria-label="lab API tabs example"
            className={classes.tabList}
            variant="fullWidth" 
          >
            {
              options.map((option, index) => {
                return (
                  <Tab
                    label={option.label}
                    value={option.value}
                    key={index}
                    className={classes.simpleTab}
                  />
                )
              })
            }
          </TabList>
        </Box>
      </TabContext>
    </Box>
  )
}